<template>
  <div class="layout">
    <Header></Header>
    <el-scrollbar :height="computedHeight" min-size="0">
      <RouterView></RouterView>
    </el-scrollbar>
    <ChatConversation v-if="!isProduction" />
  </div>
</template>
<script setup>
import Header from "../components/Header/Header.vue";
import ChatConversation from "../components/ChatConversation.vue";
import { onMounted, ref, watchEffect} from "vue";
import {useRoute} from "vue-router";

const route = useRoute()

const isProduction = process.env.NODE_ENV === "production";

const computedHeight = ref(`${window.innerHeight - 48}px`)
onMounted(() => {
  watchEffect(() => {
    computedHeight.value = `${window.innerHeight - 48}px`;
  });
  // 监听窗口 resize 事件
  window.addEventListener('resize', () => {
    computedHeight.value = `${window.innerHeight - 48}px`;
  });
});

</script>
<style lang="less" scoped></style>
